/**
 * App Update Notification
 * Shows a banner when a new version is available
 */

import React, { useState, useEffect } from 'react';
import {
  Snackbar,
  Alert,
  Button,
  Box
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

export default function UpdateNotification() {
  const [showUpdate, setShowUpdate] = useState(false);
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    // Listen for service worker updates
    const handleUpdate = (event) => {
      console.log('🔄 Update available!');
      setRegistration(event.detail);
      setShowUpdate(true);
    };

    window.addEventListener('swUpdateAvailable', handleUpdate);

    return () => {
      window.removeEventListener('swUpdateAvailable', handleUpdate);
    };
  }, []);

  const handleUpdate = () => {
    if (registration && registration.waiting) {
      // Tell the service worker to skip waiting
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      
      // Reload the page
      window.location.reload();
    }
  };

  const handleDismiss = () => {
    setShowUpdate(false);
    // Show again after 1 hour if not updated
    setTimeout(() => setShowUpdate(true), 60 * 60 * 1000);
  };

  return (
    <Snackbar
      open={showUpdate}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ mt: 2 }}
    >
      <Alert
        severity="info"
        variant="filled"
        onClose={handleDismiss}
        action={
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              color="inherit"
              size="small"
              startIcon={<RefreshIcon />}
              onClick={handleUpdate}
              sx={{ fontWeight: 600 }}
            >
              Update Now
            </Button>
          </Box>
        }
      >
        A new version is available! Update for the latest features and fixes.
      </Alert>
    </Snackbar>
  );
}












